import { render, staticRenderFns } from "./ReturnTable.vue?vue&type=template&id=47ae7386&"
import script from "./ReturnTable.vue?vue&type=script&lang=js&"
export * from "./ReturnTable.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports